
import CircularChart from "./chart/CircularChart";

const VitalGraph = ({vitalData:vital}) => {

  const getColor = (value) => {
    if (!vital?.is_range_applicable) {
      return {
        color: "#4BB543",
      };
    }
    if (value < vital?.allowed_range?.lower_limit) {
      return {
        color: "#B33A3A",
      };
    } else if (value > vital?.allowed_range?.upper_limit) {
      return {
        color: "#B33A3A",
      };
    }
    let color = "#B33A3A";

    if (
      value >= vital?.normal_range?.lower_limit &&
      value <= vital?.normal_range?.upper_limit
    ) {
      color = "#4BB543";
    } else if (value < vital?.normal_range?.lower_limit) {
      return {
        color: "#B33A3A",
      };
    } else if (value > vital?.normal_range?.upper_limit) {
      return {
        color: "#B33A3A",
      };
    }

    return { color };
  };
  return (
<div className="flex flex-col sm:flex-row gap-4 h-full w-full  rounded-[34px]   ">
          <div className="flex justify-center items-center sm:w-96">
            <CircularChart height={240} width={240} size='small' vital={vital} color={getColor(vital.value).color} />
          </div>
          <div className="flex flex-col gap-4 px-4 sm:py-6 sm:justify-center">
            <h1 className="font-semibold text-lg">{vital?.display_name} </h1>
          <div className="w-35 grid grid-cols-2 sm:grid-cols-1 gap-2 ">
            <div className="w-15 flex justify-start items-center  font-regular text-[16px] text-[#32365C]">
              <div
                className="rounded-full  h-[10px] w-[10px]"
                style={{ backgroundColor: "#B33A3A" }}
              ></div>
              <p className="ms-1">
                Low {vital?.allowed_range?.lower_limit} -{" "}
                {vital?.normal_range?.lower_limit}
              </p>
            </div>

            <div className="w-15 flex justify-start items-center  font-regular text-[16px] text-[#32365C]">
              <div
                className="rounded-full  h-[10px] w-[10px]"
                style={{ backgroundColor: "#4BB543" }}
              ></div>
              <p className="ms-1">
                Normal {vital?.normal_range?.lower_limit}
                {"-"}
                {vital?.normal_range?.upper_limit} {"  "}
              </p>
            </div>
            <div className="w-15 flex justify-start items-center  font-regular text-[16px] text-[#32365C]">
              <div
                className="rounded-full  h-[10px] w-[10px]"
                style={{ backgroundColor: "#B33A3A" }}
              ></div>
              <p className="ms-1">
                High {vital?.normal_range?.upper_limit} -{" "}
                {vital?.allowed_range?.upper_limit}
              </p>
            </div>
          </div>

          </div>
        </div>
  );
};

export default VitalGraph;
